module.exports = __webpack_public_path__ + "static/media/SantaFe.2ebadf1e.svg";